import BigNumber from 'bignumber.js'

const TEN = new BigNumber(10)

/** Converts a number to the contract decimals format */
const toContractNumberBN = (value: string, decimals: string | number) => {
  const multiplier = TEN.pow(decimals)

  return new BigNumber(value, 10)
    .multipliedBy(multiplier)
    .decimalPlaces(0, BigNumber.ROUND_DOWN)
}
/** Converts a number to the contract decimals format */
const toContractNumber = (value: string, decimals: string | number) => {
  if (decimals === '0') return value

  return toContractNumberBN(value, decimals).toString(10)
}

/** Converts a number from contract to BN */
const fromContractNumberBN = (value: string, decimals: string | number) => {
  const multiplier = TEN.pow(decimals)

  return new BigNumber(value, 10)
    .decimalPlaces(0, BigNumber.ROUND_DOWN)
    .div(multiplier)
}

/** Converts a number from contract to BN */
const fromContractNumber = (value: string, decimals: string | number) => {
  if (decimals === '0') return value
  return fromContractNumberBN(value, decimals).toString(10)
}

export {
  toContractNumber,
  fromContractNumber,
  fromContractNumberBN,
  toContractNumberBN,
}
